import type { UseQueryResult } from "@tanstack/react-query";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { retryQueryOnUnauthorizedError } from "app/pages/sales-intelligence/query/utils";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { ICompanyOpportunitySpotted } from "../../types/CompanyOpportunitySpotted";
import type { IRowsDtoWrapper } from "../../types/rowsDtoWrapper";
import { topCompaniesQueryKeys } from "../queryKeys/queryKeyFactory";

function companyOpportunitySpottedToMap(
    data: IRowsDtoWrapper<readonly ICompanyOpportunitySpotted[]>,
): Map<string, string> {
    if (!data || !data.rows) {
        return new Map();
    }

    return new Map(data.rows.map(({ domain, opportunitySpotted }) => [domain, opportunitySpotted]));
}

function useCompanyOpportunitySpottedQuery(domains: readonly string[]): UseQueryResult<Map<string, string>, unknown> {
    return useQuery({
        enabled: domains.length > 0,
        queryKey: topCompaniesQueryKeys.opportunitySpotted(domains),
        placeholderData: keepPreviousData,
        retry: retryQueryOnUnauthorizedError,
        select: companyOpportunitySpottedToMap,
        queryFn({ signal }) {
            return salesApiService.home.fetchOpportunitySpotted(domains, {
                cancellation: signal,
            });
        },
    });
}

export default useCompanyOpportunitySpottedQuery;
